<div class="input--container">
  <input *ngIf="!isSpecial" [ngClass]="{'light': lightTheme}" [(ngModel)]="val" id="{{name}}" placeholder="{{value}}"
    name="{{name}}" [ngStyle]="{'text-align': alignRight ? 'right': 'left'}" (blur)="setValue()"
    (keyup)="addCommas($event.target.value)" />

  <input *ngIf="isSpecial" [ngClass]="{'light': lightTheme}" [textMask]="{mask: inflaPattern}" placeholder="0."
    [(ngModel)]="val" id="{{name}}" name="{{name}}" [ngStyle]="{'text-align': alignRight ? 'right': 'left'}"
    (blur)="setValue()" (keyup)="addCommas($event.target.value)" />

  <textarea *ngIf="textarea"></textarea>
</div>